<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>{{ title }}</strong>
                    </div>
                    <b-list-group>
                        <b-list-group-item v-for="(item,index) in listReportSyncTypes" :key="item.id">
                            <router-link :to="{ path: `/view-reports/${pathReportType}/${item.id}` }">
                                {{index + 1 + ". " + item.text }}
                            </router-link>
                        </b-list-group-item>
                    </b-list-group>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    export default {
        name: 'ListReport',
        data() {
            return {
                title: '',
                pathReportType: ''
            }
        },
        computed: {
            listReportSyncTypes() {
                if (this.$route.meta.infoTypes) {
                    var types = JSON.parse(JSON.stringify(this.$store.state.common.listReportSyncTypes));
                    var privileges = this.$store.state.identity.privileges;

                    return types
                        .filter(x => this.$route.meta.infoTypes.indexOf(x.id) != -1)
                        .filter(x => privileges.indexOf('ViewReport_' + x.table.substr(4)) != -1)
                        .sort();
                } else {
                    return [];
                }
            }
        },
        created() {
            this.title = this.$route.meta.label;
            this.pathReportType = this.$route.meta.pathReportType;
        },
        methods: {

        }
    }
</script>
<style scoped>
</style>
